import * as e from "react";
import { forwardRef as C } from "react";
const c = C(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M14.9488 6.50195C14.7549 6.50195 14.569 6.57897 14.4319 6.71606C14.2948 6.85316 14.2178 7.03909 14.2178 7.23297C14.2178 7.42685 14.2948 7.61279 14.4319 7.74988C14.569 7.88697 14.7549 7.96399 14.9488 7.96399H22.7463C22.9402 7.96399 23.1261 7.88697 23.2632 7.74988C23.4003 7.61279 23.4773 7.42685 23.4773 7.23297C23.4773 7.03909 23.4003 6.85316 23.2632 6.71606C23.1261 6.57897 22.9402 6.50195 22.7463 6.50195H14.9488ZM17.8729 11.6059C17.679 11.6059 17.493 11.6829 17.356 11.82C17.2189 11.9571 17.1418 12.143 17.1418 12.3369C17.1418 12.5308 17.2189 12.7167 17.356 12.8538C17.493 12.9909 17.679 13.0679 17.8729 13.0679H22.7463C22.9402 13.0679 23.1261 12.9909 23.2632 12.8538C23.4003 12.7167 23.4773 12.5308 23.4773 12.3369C23.4773 12.143 23.4003 11.9571 23.2632 11.82C23.1261 11.6829 22.9402 11.6059 22.7463 11.6059H17.8729ZM18.1165 17.4409C18.1165 17.2471 18.1936 17.0611 18.3306 16.924C18.4677 16.7869 18.6537 16.7099 18.8476 16.7099H22.7463C22.9402 16.7099 23.1261 16.7869 23.2632 16.924C23.4003 17.0611 23.4773 17.2471 23.4773 17.4409C23.4773 17.6348 23.4003 17.8208 23.2632 17.9578C23.1261 18.0949 22.9402 18.172 22.7463 18.172H18.8476C18.6537 18.172 18.4677 18.0949 18.3306 17.9578C18.1936 17.8208 18.1165 17.6348 18.1165 17.4409Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: 7.16667,
        cy: 12.4167,
        r: 5.41667,
        stroke: "currentColor",
        strokeWidth: 1.66667
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M11.3335 16.5835L14.2502 19.5002",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 1.66667
      }
    )
  );
});
export {
  c as SearchMenu
};
